import { render } from "./AssessmentBadge.vue?vue&type=template&id=469038b6"
import script from "./AssessmentBadge.vue?vue&type=script&lang=ts"
export * from "./AssessmentBadge.vue?vue&type=script&lang=ts"
script.render = render

export default script